module.exports = __webpack_public_path__ + "static/media/managePaymentLink.mobile.d38552ff.svg";